// Why Choose Us Section
export default function WhyChooseSection() {
  return (
    <div className="py-16 bg-zinc-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Why Choose Us</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            We bring years of experience and industry best practices to help you achieve DevOps excellence.
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {/* Reason 1 */}
          <div className="bg-gray-50 rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="bg-indigo-100 p-3 rounded-lg inline-block">
              <svg className="h-8 w-8 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="mt-4 text-xl font-medium text-gray-900">Experienced Team</h3>
            <p className="mt-3 text-gray-600">
              Our consultants have over 10+ years of experience working with Fortune 500 companies and startups alike, bringing proven methodologies and best practices.
            </p>
          </div>
          
          {/* Reason 2 */}
          <div className="bg-gray-50 rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="bg-indigo-100 p-3 rounded-lg inline-block">
              <svg className="h-8 w-8 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="mt-4 text-xl font-medium text-gray-900">Rapid Implementation</h3>
            <p className="mt-3 text-gray-600">
              We deliver results quickly with our proven accelerators and toolkits, helping you realize value from your DevOps transformation faster.
            </p>
          </div>
          
          {/* Reason 3 */}
          <div className="bg-gray-50 rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="bg-indigo-100 p-3 rounded-lg inline-block">
              <svg className="h-8 w-8 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="mt-4 text-xl font-medium text-gray-900">Client-Centric Approach</h3>
            <p className="mt-3 text-gray-600">
              We tailor our solutions to your specific needs, ensuring that our DevOps implementations align with your business goals and technical requirements.
            </p>
          </div>
        </div>
        
        {/* <div className="mt-16 text-center">
          <a href="#" className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700">
            Learn More About Our Approach
          </a>
        </div> */}
      </div>
    </div>
  );
};

